/**
 * Printable certificate from HTML template + placeholder fill.
 */
import React, { useMemo } from "react";
import { Box } from "@mui/material";

import { useAsterController } from "context";
import {
  CERT_A4_WIDTH_PX,
  buildCertificateLearnerValues,
  fillHtmlTemplate,
  resolveCertificateContent,
} from "utils/certificateTemplate";

/**
 * Renders a themed certificate for PDF capture from stored HTML.
 *
 * @param {{ courseTitle: string, runStart: string, runEnd: string, duration: *, created: string, objective: string[] }} props
 */
const SettingsDocumentCertificate = (props) => {
  const { courseTitle, runStart, runEnd, duration, created, objective } = props;

  const [controller] = useAsterController();
  const { user, themes, certVar } = controller;

  const studentName = Object.keys(user || {}).length
    ? `${user.first_name} ${user.last_name || user.username}`
    : "(Empty)";

  const colorMain1 = useMemo(
    () => (themes || []).find((v) => v.name === "color_main1")?.value || "#E40473",
    [themes]
  );

  const logoUrl = useMemo(() => process.env.REACT_APP_LOGO_URL || "", []);
  const signatureUrl = useMemo(() => certVar?.signature_url || "", [certVar?.signature_url]);

  const filledHtml = useMemo(() => {
    if (!Object.keys(certVar || {}).length) return "";
    const template = resolveCertificateContent(certVar.content);
    return fillHtmlTemplate(
      template,
      buildCertificateLearnerValues({
        studentName,
        courseTitle,
        runStart,
        runEnd,
        duration,
        created,
        objectives: objective || [],
        certVar,
        meta: {
          colorMain1,
          logoUrl,
          signatureUrl,
          platformName: process.env.REACT_APP_SITE_DISPLAY_NAME || "Ampela",
        },
      })
    );
  }, [
    certVar,
    studentName,
    courseTitle,
    runStart,
    runEnd,
    duration,
    created,
    objective,
    colorMain1,
    logoUrl,
    signatureUrl,
  ]);

  if (!filledHtml) return null;

  return (
    <Box
      sx={{ width: `${CERT_A4_WIDTH_PX}px`, margin: "0 auto", background: "#fff", position: "relative" }}
      dangerouslySetInnerHTML={{ __html: filledHtml }}
    />
  );
};

export default SettingsDocumentCertificate;
